import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { assetsForYouRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsForYouRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { assetsForYouEntryPoint } from '@atlassian/jira-assets-app-for-you-page/src/entrypoint.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const assetsForYouPageEntryPoint = createChromelessEntryPoint({
	main: assetsForYouEntryPoint,
});

export const assetsForYouRouteEntry = createEntry(assetsForYouRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => (fg('assets_for_you') ? assetsForYouPageEntryPoint : undefined),
	pageId: () => 'spa-apps/assets/for-you-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.interact-with-for-you-page',
	ufoName: 'assets-app-for-you-page',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsForYouRouteEntry.tsx',
			whichExportToUse: 'assetsForYouRouteEntry',
		},

		enabled: true,
	},
}));
